import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiUsers {
  static getUsers(companyId) {
    let query = "";
    if (companyId && companyId.length) {
      query = `?company_id=${companyId}`;
    }
    return apiFetch(`${ApiBaseUrl}users${query}`);
  }

  static getInternalUsers() {
    return apiFetch(`${ApiBaseUrl}users/internal`);
  }

  static getInternalPrimaryUsers() {
    return apiFetch(`${ApiBaseUrl}users/internal_primary`);
  }

  static getUserRoles() {
    return apiFetch(`${ApiBaseUrl}users/roles`);
  }

  static inviteUser({ user, companyId }) {
    let query = "";
    if (companyId && companyId.length) {
      query = `?company_id=${companyId}`;
    }
    return apiFetch(`${ApiBaseUrl}users/invite${query}`, {
      method: "POST",
      body: { user },
    });
  }

  static register(params) {
    return apiFetch(`${ApiBaseUrl}register`, { anon: true, method: "POST", body: params });
  }

  static confirmInvitedUser({ invitation_token, password, password_confirmation }) {
    return apiFetch(`${ApiBaseUrl}users/invitation`, {
      anon: true,
      method: "PUT",
      body: { user: { invitation_token, password, password_confirmation } },
    });
  }

  static loginUser({ email, password }) {
    return apiFetch(`${ApiBaseUrl}users/sign_in`, {
      anon: true,
      method: "POST",
      body: { user: { email, password } },
      fetchFn: window.AwsWafIntegration?.fetch,
      onResponse: async res => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Login failed");
        const token = [...res.headers].find(([key]) => key === "authorization")?.[1];
        if (!token) throw new Error("Token is null");
        return { ...data, id_token: token.split(" ")[1] };
      },
    });
  }

  static sendResetLoginUser(email) {
    return apiFetch(`${ApiBaseUrl}users/password`, {
      anon: true,
      method: "POST",
      body: { user: { email } },
      onResponse: async res => {
        const json = await res.json();
        if (res.status == 422) throw new Error(json.status);
        if (!res.ok) throw new Error("Error occured, please retry later");
        return json;
      },
    });
  }

  static loginSSO(companyId) {
    return apiFetch(`${ApiBaseUrl}sso/login`, { anon: true, query: { company_id: companyId } });
  }

  static getEmailCompany(email) {
    return apiFetch(`${ApiBaseUrl}sso/company`, {
      anon: true,
      query: { email },
      onResponse: async res => {
        if (!res.ok)
          throw new Error(
            "SSO is not enabled for this domain. Please contact your customer service manager if you would like to enable this feature.",
          );
        return res.json();
      },
    });
  }

  static getUser() {
    return apiFetch(`${ApiBaseUrl}users/me`);
  }

  static resetPasswordUser({ reset_password_token, password, password_confirmation }) {
    return apiFetch(`${ApiBaseUrl}users/password`, {
      method: "PUT",
      body: { user: { reset_password_token, password, password_confirmation } },
    });
  }

  static logoutUser() {
    return apiFetch(`${ApiBaseUrl}users/sign_out`, {
      method: "DELETE",
    });
  }

  static updateUser({ user, companyId, updatePermissions }) {
    let queryStr = "";
    if (updatePermissions) {
      const query = ["update_permissions=true"];
      if (companyId && companyId.length) {
        query.push(`company_id=${companyId}`);
      }

      queryStr = `?${query.join("&")}`;
    }

    return apiFetch(`${ApiBaseUrl}users/${user.id}${queryStr}`, {
      method: "PUT",
      body: { user },
    });
  }

  static updateUserSettings({ user }) {
    return apiFetch(`${ApiBaseUrl}users/${user.id}/update_settings`, {
      method: "PUT",
      body: { user: { settings: user.settings } },
    });
  }

  static deleteUser({ userId, isAdminingCompany, appId }) {
    const query = [];
    let queryStr = "";
    if (isAdminingCompany) {
      query.push("is_admining_company=true");
    }

    if (appId) {
      query.push(`app_id=${appId}`);
    }

    if (query.length) {
      queryStr = `?${query.join("&")}`;
    }

    return apiFetch(`${ApiBaseUrl}users/${userId}${queryStr}`, {
      method: "DELETE",
    }).then(() => userId);
  }

  static getConfig() {
    return apiFetch(`${ApiBaseUrl}auth/config`, { anon: true });
  }
}
